const DynamicElectionRoutingController = function (
    $scope,
    $rootScope,
    AccountService,
    DynamicElectionRoutingService
) {
    $scope.available = false;
    $scope.endTime = new Date("2051-12-25T22:01:01.000Z").valueOf();
    $scope.startTime = new Date("2021-12-25T22:01:01.000Z").valueOf();
    $scope.individualId = "";
    $scope.gaID = "";
    $scope.planName = "";
    $scope.firstName = "";
    $scope.lastName = "";
    $scope.email = "";

    AccountService.getPrimaryGroupAccount().then((data) => {
        const id = {
            individual: data.individualId,
            ga: data.groupId
        };
        $scope.individualId = data.individualId;
        $scope.gaID = data.groupId;

        DynamicElectionRoutingService.getDetails(id).then(function success(data) {
            $scope.planName = data.name;
            $scope.firstName = data.firstName;
            $scope.lastName = data.lastName;
        });
    });

    $scope.init = function (endTime, startTime) {
        endTime && ($scope.endTime = new Date(endTime).valueOf());
        startTime && ($scope.startTime = new Date(startTime).valueOf());
    };

    DynamicElectionRoutingService.getTime().then(function success(data) {
        $scope.currentTime = new Date(data.currentTime).valueOf();

        if ($scope.currentTime < $scope.endTime && $scope.currentTime > $scope.startTime) {
            $scope.available = true;
        }
    });

    DynamicElectionRoutingService.getContactDetails().then(function success(data) {
        $scope.email = data.personalEmailAddress;
    });
};

DynamicElectionRoutingController.$inject = [
    "$scope",
    "$rootScope",
    "AccountService",
    "DynamicElectionRoutingService"
];
export default DynamicElectionRoutingController;
